<template>
  <pui-input
    ref="editor"
    type="checkbox"
    :disabled="editor.disabled"
    :value="getValue"
    @change="onValueChanged"
    @blur="onBlur"
  >
  </pui-input>
</template>
<script>
import TableAttributeEditorMixin from './TableAttributeEditorMixin';

export default {
  components: {},
  mixins: [TableAttributeEditorMixin],
};
</script>
